import {SAVE_MAP_ZOOM} from "../../../actions/types";

export const saveMapZoom = (zoomLevel) => {
    return (dispatch) => {
        dispatch({ type: SAVE_MAP_ZOOM, payload: zoomLevel });
    }
};
